import { Record } from "../../../records/server/crud";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  MachineConfigurationCellClassService,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "../../../machines/shared/machineConfigurationCellClassService";
import { ConfigurableGridFormViewConfig } from "../../../records/views/configurableGridFormView/controller";
import { vsObjectName as progressiveDefinitionMachineName } from "../../configs/progressiveDefinitionMachine";
import {
  DoubleClickHandlerService,
  vsName as DoubleClickHandlerServiceName,
} from "../../../records/grids/cells";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { ProgressivePermissions } from "../../../machines.progressives/permissions";
import fieldHelpers from "../../../ui-formly/fieldHelpers";
import {
  ProgressiveComponentsModuleConfig,
  vsConfigName as moduleConfigName,
} from "../../moduleConfig";

export class ProgressiveDefinitionMachinesViewComponentController {
  static $inject = [
    MachineConfigurationCellClassServiceName,
    RecordGridViewServiceName,
    DoubleClickHandlerServiceName,
    ColumnDefinitionServiceName,
    ServerUtilityName,
    moduleConfigName,
  ];

  constructor(
    private readonly machineConfigurationCellClassService: MachineConfigurationCellClassService,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly doubleClickHandlerService: DoubleClickHandlerService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly serverUtility: ServerUtility,
    private readonly moduleConfig: ProgressiveComponentsModuleConfig
  ) {
    this.gridConfiguration = this.recordGridViewService.getGridConfiguration(
      progressiveDefinitionMachineName
    )!;
  }

  private readonly gridConfiguration: GridConfiguration;
  private readonly progressiveDefinition!: Record;

  public configurableGridFormViewConfig:
    | ConfigurableGridFormViewConfig
    | undefined;

  $onInit() {
    const columns = (this.gridConfiguration.columns = [
      this.columnDefinitionService.getLinkColDef({
        stateExpression:
          "main.machines.detail.configurations({ machineId: data.MachineId})",
        colId: "detail",
        headerName: "info",
        iconClass: "fa fa-info-circle text-primary",
      }),
      ...(this.gridConfiguration.columns ?? []),
    ]);

    const notesColumn = columns.find((c) => c.field === "Notes");
    if (notesColumn) {
      notesColumn.cellDoubleClicked = this.notesColumnDoubleClicked();
    }

    this.configurableGridFormViewConfig = {
      defaultQuery: {
        ProgressiveDefinitionId: this.progressiveDefinition.Id,
        Active: true,
      },
      gridConfiguration: this.gridConfiguration,
      additionalToggleButtons: [
        {
          id: "activeConfigurationsOnly",
          text: "Active Configurations Only",
          checked: true,
          onChanged(toggleButton, controller) {
            controller.config.defaultQuery.Active = toggleButton.checked
              ? true
              : undefined;
          },
        },
      ],
      showNavButton: this.moduleConfig.allowMachineEdit,
      navPath: ".edit",
      navButtonIcon: "fa-pencil",
      navButtonText: "Edit",
      navButtonPermission: "machines.progressives.write",
    };
    this.machineConfigurationCellClassService.styleColumns(columns, true);
  }

  private notesColumnDoubleClicked() {
    return this.doubleClickHandlerService.patchDoubleClickHandler({
      requiresPermission: ProgressivePermissions.EditPermission,
      fetchRecord: (args) =>
        this.serverUtility.querySingleWrapped({
          url: this.gridConfiguration.gridDataSource!.url,
          query: { Id: args.data.Id },
        }),
      submit: (patchObject) =>
        this.serverUtility.patch({
          url: `/api/machines/progressives/ProgressiveDefinitionMachine`,
          patchObject,
        }),
      patchField: {
        formField: {
          ...fieldHelpers.textAreaField({
            key: "Notes",
            name: "Notes",
            label: "Notes",
            rows: 5,
            required: false,
          }),
          type: "gridTextarea",
        },
      },
    });
  }
}
